import {Validators} from '@angular/forms';
import {FieldTypeEnum} from '../../../projects/mydocma/dynamic-form/src/lib/dynamic-field/field-type.enum';

export const fieldsMap = new Map<FieldTypeEnum, any>([
    [FieldTypeEnum.button, {
        id: 'button1',
        name: 'button1',
        type: FieldTypeEnum.button,
        label: 'fields.button1',
        required: true,
    }],
    [FieldTypeEnum.checkbox, {
        id: 'checkbox1',
        name: 'checkbox1',
        type: FieldTypeEnum.checkbox,
        label: 'fields.checkbox1',
        required: true,
        validators: [Validators.required]
    }],
    [FieldTypeEnum.date, {
        id: 'date',
        name: 'date',
        type: FieldTypeEnum.date,
        label: 'fields.date1',
        required: true,
        readonly: true,
        maxDate: new Date(2020, 0, 1)
    }],
    [FieldTypeEnum.datetime, {
        id: 'datetime1',
        name: 'datetime1',
        label: 'fields.datetime1',
        type: FieldTypeEnum.datetime,
        required: true,
    }],
    [FieldTypeEnum.icon, {
        id: 'icon1',
        name: 'icon1',
        type: FieldTypeEnum.icon,
        label: 'fields.icon1',
        required: true,
        value: 'search'
    }],
    [FieldTypeEnum.image,     {
        id: 'image',
        name: 'image',
        type: FieldTypeEnum.image,
        label: 'fields.image1',
        width: '400px',
        height: '300px',
        value: 'https://i.ytimg.com/vi/1Ne1hqOXKKI/maxresdefault.jpg'
    }],
    [FieldTypeEnum.number,     {
        id: 'number',
        name: 'number',
        type: FieldTypeEnum.number,
        label: 'fields.number1',
        required: true,
        readonly: false,
        maxValue: 12,
    }],
    [FieldTypeEnum.select, {
        id: 'select',
        name: 'select',
        type: FieldTypeEnum.select,
        label: 'fields.select1',
        required: true,
        source: [{key: 'item1', value: '1'}, {key: 'item2', value: '2'}]
    }],
    [FieldTypeEnum.text, {
        id: 'text',
        name: 'text',
        type: FieldTypeEnum.text,
        label: 'fields.text1',
        required: true,
        maxLength: 12,
        minLength: 3,
        suffix: {
            tooltip: 'it is tooltop',
            icon: 'search'
        }
    }],
    [FieldTypeEnum.textarea, {
        id: 'textarea',
        name: 'textarea',
        type: FieldTypeEnum.textarea,
        label: 'fields.textarea1',
        required: true,
        maxLength: 12,
        minLength: 2,
        maxRows: 10,
        minRows: 2
    }],
    [FieldTypeEnum.time, {
        id: 'time1',
        name: 'time1',
        type: FieldTypeEnum.time,
        label: 'fields.time1',
        required: true,
    }],
    [FieldTypeEnum.option, {
        id: 'option1',
        name: 'option1',
        type: FieldTypeEnum.option,
        label: 'fields.option1',
        required: true,
        options: [{optionLabel: 'Paris', optionValue: 'Paris'}, {optionLabel: 'London', optionValue: 'London'}]
    }],
]);

